import { render, staticRenderFns } from "./WholesalerEditView.vue?vue&type=template&id=512569e4"
import script from "./WholesalerEditView.vue?vue&type=script&lang=ts"
export * from "./WholesalerEditView.vue?vue&type=script&lang=ts"
import style0 from "./WholesalerEditView.vue?vue&type=style&index=0&id=512569e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports